<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Anticipos
		</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<!-- <div class="row" id="options-date">
					<div class="col-sm form-group">
						<label for="type" class="form-label">Ver resultados de </label>
						<select name="type" id="type" (change)="changeType()" [(ngModel)]="type" class="form-select">
							<option value="0">Hoy</option>
							<option value="1">Últimos 7 días</option>
							<option value="2">Este mes</option>
							<option value="3">El mes pasado</option>
							<option value="4">Últimos dos meses</option>
							<option value="5">Últimos tres meses</option>
							<option value="6">Intervalo de fecha</option>
						</select>
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="startDate" class="form-label">Fecha Inicio</label>
						<input type="date" id="startDate" [(ngModel)]="startDate"
							name="startDate" class="form-control">
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="endDate" class="form-label">Ver resultados de </label>
						<input type="date" id="endDate" max="{{todayDate | date:'yyyy-MM-dd'}}"
							[(ngModel)]="endDate" name="endDate" class="form-control">
					</div>
					<div class="col-auto form-group" *ngIf="type==6">
						<div class="h-100 row align-items-end">
							<button class="btn btn-success" (click)="changeDate()" [disabled]="loadingData">
								<span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingData"></span>
								<i class="fa fa-filter" *ngIf="!loadingData"></i>
							</button>
						</div>
					</div>
				</div> -->
				<div class="row" style="margin-top: 1em;" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Número o serie</label>
						<div class="input-group">
							<input type="text" id="filterVendors" [(ngModel)]="searchVendor"
								placeholder="Ingresa número o serie" name="filterVendors" class="form-control">
							<button class="btn btn-primary" (click)="filtering()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
					<!-- <div class="col-sm form-group">
						<label for="filterWarehouse" class="form-label">Bodega</label>
						<select name="filterWarehouse" [(ngModel)]="warehouseSelected" id="filterWarehouse"
							(change)="filtering()" class="form-select">
							<option value="-1">Todas</option>
							<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">{{warehouse.name}}
							</option>
						</select>
					</div> -->
					<!-- <div class="col-sm form-group">
						<label for="order" class="form-label">Orden </label>
						<select name="order" id="order" (change)="changeOrder()" [(ngModel)]="isAscendent"
							class="form-select">
							<option value="1">Ascendente</option>
							<option value="0">Descendente</option>
						</select>
						<span class="form-text">
							<i class="fa fa-circle-info"></i>
							<ng-container *ngIf="isAscendent==1">
								Los resultados se muestran de la fecha más lejana a la más reciente
							</ng-container>
							<ng-container *ngIf="isAscendent==0">
								Los resultados se muestran de la fecha más reciente a la más lejana
							</ng-container>
						</span>
					</div> -->
				</div>
				<div class="table-responsive"
					style="margin-bottom: 0;">
					<table class="table table-striped" style="margin-bottom: 0;">
						<thead>
							<tr>
								<th class="ta">
									Beneficiario
								</th>
								<th class="ta">
									Fecha
								</th>
								<th class="ta">
									No. Doc
								</th>
								<th class="ta">
									Caja
								</th>
								<th class="ta">
									Anticipo
								</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="!loadingData">
								<ng-container *ngFor="let item of pagination.filter">
									<tr>
										<td class="ta">
											{{item.beneficiary}}
										</td>
										<td class="ta">
											{{convertToString(item.date)}}
										</td>
										<td class="ta">
											{{item.docNumber}}
										</td>
										<td class="ta">
											{{item.rootLocation}}
										</td>
										<td class="ta">
											{{(item.amount || 0) | currency : ((item.currency == 1) ? '$' : 'Q')}}
										</td>
										<td class="ta">
											<div style="display: flex; justify-content: center;">
												<!-- <span class="clickeable text-info" title="Editar"
													(click)="editInvoice(invoice)" [appCheckPermission]="[2046]"
													[permissionType]="permissionType.UPDATE">
													<i class="fa fa-edit"></i>
												</span> -->
												<span (click)="downloadAdvance(item)" title="Descargar"
													class="clickeable text-info" [appCheckPermission]="[2046]"
													[permissionType]="permissionType.READ">
													<i *ngIf="!loadingDownload[item.id]"
														class="fa-solid fa-download"></i>
													<span *ngIf="loadingDownload[item.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
												</span>
												<span (click)="detailingInvoice(item)" title="Ver"
													class="clickeable text-info" [appCheckPermission]="[2046]"
													[permissionType]="permissionType.READ">
													<i *ngIf="!detailing[item.id]" class="fa fa-eye"></i>
													<span *ngIf="detailing[item.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
												</span>
											</div>
										</td>
									</tr>
								</ng-container>
							</ng-container>
							<tr class="tr-middle" *ngIf="loadingData">
								<td colspan="10">
								<app-loading-animation [height]="'5rem'"></app-loading-animation>
								<p class="display-6">Cargando...</p>
								</td>
							</tr>
							<tr *ngIf="pagination.filter.length == 0 && !loadingData">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>
									{{sales.length == 0?'No se encontraron ventas en las fechas seleccionadas':
									'No se encontraron resultados para el filtro aplicado'}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
	
</div>


<app-modal-dialog [show]="showModal" (closed)="showModal = false"  size="lg" position="top" #modal>
    <div class="modal-header" modal-header>
        <h3>Detalle de Anticipo</h3>
        <h4 class="i-hover ml-4">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h4>
    </div>

    <div class="modal-body" modal-body>
        <div class="d-flex flex-column" *ngIf="advanceSelected!=null">
            <div class="d-flex flex-row flex-wrap gap-4">
                <h6 class="font-bold">Beneficiario: <span class="font-medium">{{advanceSelected.beneficiary}}</span></h6>
                <h6 class="font-bold">Numero Doc: <span class="font-medium">{{advanceSelected.docNumber}}</span></h6>
            </div>
            <div class="d-flex flex-row flex-wrap gap-4">
                <h6 class="font-bold">Origen: <span class="font-medium">{{advanceSelected.rootLocation}}</span></h6>
				<h6 class="font-bold">Fecha: <span class="font-medium">{{convertToString(advanceSelected.date)}}</span></h6>
            </div>
			<div class="d-flex flex-row flex-wrap gap-4">
                <!-- <h6 class="font-bold">Total Anticipo: <span class="font-medium">{{advanceSelected.issuedAmount}}</span></h6> -->
                <h6 class="font-bold">Anticipo: <span class="font-medium">{{advanceSelected.amount | currency: (advanceSelected.currency==0? 'Q':'$')}}</span></h6>
            </div>
        </div>
        <div class="row" *ngIf="advanceSelected!=null">
            <div class="table-responsive" style="margin-bottom: 0;">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="ta">
                                #
                            </th>
                            <th class="">
                                Nombre
                            </th>
                            <th class="ta">
                                Cantiad
                            </th>
                            <th class="ta">
                                Precio
                            </th>
                            <th class="ta">
                                Subtotal
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of advanceDetails; let i = index">
                            <tr>
                                <td>{{i+1}}</td>
                                <td class="limit-td-300">{{item.productName}}</td>
                                <td>{{item.quantity | number:'1.2-2'}}</td>
                                <td>{{item.price | currency: (advanceSelected.currency==0? 'Q':'$')}}</td>
                                <td class="text-right">{{subtotal(item.quantity,item.price) | currency: (advanceSelected.currency==0? 'Q':'$')}}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td colspan="4"> Total</td>
                            <td class="font-bold text-right">{{total | currency: (advanceSelected.currency==0? 'Q':'$')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
					
        </div>
    </div>
</app-modal-dialog>